export const cssReset = {
  ':where(html)': {
    colorScheme: 'light dark',
    hangingPunctuation: 'first allow-end last',
    interpolateSize: 'allow-keywords',
    scrollBehavior: 'smooth',
    scrollbarGutter: 'stable',
    textSizeAdjust: 'none',
    WebkitTextSizeAdjust: 'none',
    WebkitTapHighlightColor: 'transparent',
    WebkitFontSmoothing: 'antialiased',
  },
  ':where(html.translated-rtl)': {
    direction: 'rtl',
  },
  '@media (prefers-reduced-motion: reduce)': {
    ':where(html)': {
      scrollBehavior: 'auto',
    },
  },
  ':where(body)': {
    minBlockSize: '100svb',
    minInlineSize: '300px',
    lineHeight: 1,
  },
  ':where(canvas, img, picture, svg, video)': {
    blockSize: 'auto',
    border: 'none',
    display: 'block',
    maxInlineSize: '100%',
  },
  ':where(button, input, progress, select, textarea)': {
    appearance: 'none',
    background: 'transparent',
    border: 'none',
    color: 'inherit',
    font: 'inherit',
    hangingPunctuation: 'none',
    lineHeight: 'inherit',
    textAlign: 'start',
    touchAction: 'manipulation',
  },
  ':where(button)': {
    cursor: 'pointer',
    userSelect: 'none',
  },
  ':where(textarea)': {
    resize: 'vertical',
  },
  ':where(textarea:not([rows]))': {
    fieldSizing: 'content',
  },
  ':where(fieldset, iframe)': {
    border: 'none',
  },
  ':where(p, li, h1, h2, h3, h4, h5, h6)': {
    overflowWrap: 'break-word',
    textWrap: 'pretty',
  },
  ':where(abbr[title])': {
    border: 'none',
    textDecoration: 'none',
  },
  ':where(cite)': {
    fontStyle: 'inherit',
  },
  ':where(small)': {
    fontSize: 'inherit',
  },
  ':where(li, ol, ul)': {
    listStyle: 'none',
  },
  ':where(dialog, [popover])': {
    background: 'transparent',
    border: 'none',
    color: 'inherit',
    margin: 'auto',
    maxBlockSize: 'none',
    maxInlineSize: 'none',
    position: 'fixed',
  },
  ':where([popover])': {
    inset: 'auto',
  },
  ':where(dialog:not([open], [popover]), [popover]:not(:popover-open))': {
    display: 'none',
  },
  ':where([hidden]:not([hidden="until-found"]))': {
    display: 'none !important',
  },
  ':where(html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video)':
    {
      margin: 0,
      padding: 0,
      border: 0,
      fontSize: '100%',
      verticalAlign: 'baseline',
    },
  /* HTML5 display-role reset for older browsers */
  ':where(article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section)':
    {
      display: 'block',
    },
  ':where(blockquote, q)': {
    quotes: 'none',
  },
  ':where(blockquote:before, blockquote:after, q:before, q:after)': {
    content: ["''", 'none'],
  },
  ':where(table)': {
    borderCollapse: 'collapse',
    borderSpacing: 0,
  },
  ':where(*, *::after, *::before)': {
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
  },
};
